export enum AccessRequirement {
  OperationalMembership,
  ValidationMembership,
  SupervisionMembership,
  AdministrationMembership,
  NonErpMemberShip,
  MultiMembership,
  InvoiceRelatedGroupMembership,
  ControlMembership,
  ControlNotPPRMembership,
  ObservationMembership,
  AnalyticalMembership,
  OperationContributorMembership,
  PPRValidationMembership,
  PPRCancelationMembership,
}
